// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetPayoutResponse = App.Http.Responses.Payout.GetPayoutResponse;
import GetPayoutsRequest = App.Http.Requests.Payout.GetPayoutsRequest;
import GetPayoutsResponse = App.Http.Responses.Payout.GetPayoutsResponse;
import GetPayoutsPairsResponse = App.Http.Responses.Payout.GetPayoutsPairsResponse;
import UpdatePayoutRequest = App.Http.Requests.Payout.UpdatePayoutRequest;
import ExportResponse = App.Http.Responses.ExportResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;

class PayoutApi extends TenantBaseApi {
    async index(request: GetPayoutsRequest): Promise<GetPayoutsResponse> {
        return await this.get<GetPayoutsResponse, GetPayoutsRequest>("/payouts", {
            params: request,
        });
    }

    async pairs(request: GetPayoutsRequest): Promise<GetPayoutsPairsResponse> {
        return await this.get<GetPayoutsPairsResponse, GetPayoutsRequest>("/payouts/pairs", {
            params: request,
        });
    }

    async show(payoutId: string, request?: unknown): Promise<GetPayoutResponse> {
        return await this.get<GetPayoutResponse, unknown>(`/payouts/${payoutId}`, {
            params: request,
        });
    }

    async update(payoutId: string, request: UpdatePayoutRequest): Promise<GetPayoutResponse> {
        return await this.patch<GetPayoutResponse, UpdatePayoutRequest>(`/payouts/${payoutId}`, request);
    }

    async export(request?: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>(`/payouts/export`, request);
    }

    async exportPairs(request?: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>(`/payouts/export-pairs`, request);
    }
}

export const payoutApi = new PayoutApi();
